import React from 'react';
import styled from '@emotion/styled';

const Div = styled.div`
    padding: .5rem;
    display: flex;
    justify-content: center;
`;
const Lin = styled.a`
   text-decoration: none;
   color: white;
`;
const Footer = () => {
    return (
        <>
            <Div>
                <Lin href="https://www.instagram.com/ilustracionessofia/?utm_medium=copy_link">@IlustracionesSofia</Lin>
            </Div>
        </>

    );
}

export default Footer;